import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Styles from './styles.scss'


export default function ContentMessage({ message }) {
  if ( !message ) {
    return null
  }

  if ( message.defaultMessage ) {
    return (
      <FormattedMessage
        { ...message }
      />
    )
  }

  if ( isURL(message) ) {
    return (
      <a
        className={ Styles.link }
        href={ message }
        rel="noopener noreferrer"
        target="_blank"
      >
        { message }
      </a>
    )
  }

  return message
}

ContentMessage.propTypes = {
  message: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.shape({
      message: PropTypes.shape({
        defaultMessage: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        values: PropTypes.shape({}),
      }),
    }),
  ]),
}

function isURL(message) {
  if ( !message.startsWith ) {
    return false
  }

  return message.startsWith('http')
}
